import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=7f93fa0c&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"
import style0 from "./industry.vue?vue&type=style&index=0&id=7f93fa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f93fa0c",
  null
  
)

export default component.exports